import React, { useEffect } from "react";
import { Nav } from "../../../../layouts/navbar/nav";
import images from "../../../../constant/images";
import "./verification.css";
import {
  Navigate,
  useNavigate,
  useNavigation,
  useLocation,
  NavLink,
} from "react-router-dom";
import { useSelector } from "react-redux";
import { useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

export default function Verification() {
  const { i18n, t } = useTranslation();
    const changeLanguage = (lng) => {
      i18n.changeLanguage(lng);
    };
    const language = localStorage.getItem("i18nextLng");
    const user = localStorage.getItem("user");

  const [code, setCode] = useState(0);
  const [message, setMessage] = useState("");
  const [error, setError] = useState(null);
  const navigation = useNavigation();
  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const form = useSelector((state) => state.gtm.form);
  const navigate = useNavigate();
  const location = useLocation();

  const { source , email } = location.state||{};

  const sendCode = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/verify`,
        {
          email: form.email,
          activation_code: code,
        },
        {
          withCredentials: true,
          withXSRFToken: true,
          credentials: "include",
        }
      );

      setMessage(response.data.message);

      if (response.status == 200) {
        navigate("/register/confirmation");
      }
    } catch (error) {
      console.error(
        "Error verifying user:",
        error.response?.data.message || error.message
      );
      setError(error.response?.data.message);
    }
  };
useEffect(() => {
    if (user) {
      navigate("/home"); // or your desired route
    }
  }, [user, navigate]);
  const submitCode = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/verify-code`,
        {
          email: email,
          code: code,
        },
        {
          withCredentials: true,
          withXSRFToken: true,
          credentials: "include",
        }
      );

      if (response.status == 200) {
        setMessage(response.data.message);
        setTimeout(() => {
          // navigation.navigate('ForgotPass' , {email : email});
          navigate("/change_password", {
            state: {
              email: email,
            },
          });
        }, 1500);
      }
    } catch (error) {
      console.error(
        "Error verifying user:",
        error.response?.data || error.message
      );
    }
  };

  // requesting new activation code

  const requestNewCode = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/resend`,
        {
          email: form.email,
        },
        {
          withCredentials: true,
          withXSRFToken: true,
          credentials: "include",
        }
      );

      setMessage(response.data.message);
    } catch (error) {
      console.error(
        "Error resending activation code:",
        error.response?.data || error.message
      );
    }
  };

  useEffect(() => {


  }, [])

  return (
    <div
      className="flex flex-col gap-12  "
      style={{
        backgroundImage: `url(${images.golf_field})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
        height: "100vh",
      }}
    >
      <div>
        <Nav />
      </div>

      <div className="flex items-center justify-center w-full ">
        <div className="shadow-[0px_6px_20px_rgba(0,0,0,0.7)] bg-white p-4   md:p-12 rounded-xl w-full max-w-[80%] sm:max-w-[620px] text-center mt-0 md:mt-2.5">
          <h1 className="title">Validation</h1>
          <p className="subtitle">
          {t("verify.verification_sent")}
          </p>
          <p className="email">{form.email} </p>
          <p className="info">          {t("verify.code_validity")}
          </p>

          <div className="otp-inputs">
            <input
              type="text"
              className="otp-input bg-[#F4F5F9] border-none"
              onChange={(e) => setCode(e.target.value)}
              maxLength={4}
              placeholder={t("verify.enter_code")}
            />
          </div>

          {message && (
            <p
              className="success-message"
              style={{ color: "green", marginTop: "10px" }}
            >
              {message}
            </p>
          )}
          {error && (
            <p
              className="error-message"
              style={{ color: "red", marginTop: "10px" }}
            >
              {error}
            </p>
          )}

          <button
            className="verify-button "
            onClick={() => {
              if (source == 0) {
                return sendCode();
              } else {
                return submitCode();
              }
            }}
          >
            {t("verify.verify")}
          </button>

          <button className="resend-button " onClick={requestNewCode}>
          {t("verify.resend_code")}
          </button>

          <p className="error-message"></p>

          <div className="text-[7px] xs:text-xs sm:text-[12px] text-center text-[#666] pt-[40px]">
              {t("login.help_message")} <br className="hidden xs:block" />
              {language === "fr" ? "Voir les" : "See the"}{" "}
              <NavLink
                to="/termes-et-conditions"
                className="text-blue-500 no-underline hover:underline"
              >
                {language === "fr"
                  ? "Conditions d'utilisation"
                  : "Terms of Use"}
              </NavLink>
              ,{" "}
              <NavLink
                to="/conditions-de-notification"
                className="text-blue-500 no-underline hover:underline"
              >
                {language === "fr"
                  ? "Conditions de notification"
                  : "Notification conditions"}
              </NavLink>
              ,{" "}
              <NavLink
                to="/conditions-de-paiement"
                className="text-blue-500 no-underline hover:underline"
              >
                {language === "fr"
                  ? "Conditions de paiement"
                  : "Payment conditions"}
              </NavLink>
              {language === "fr" ? ", et la" : ", and"}{" "}
              <NavLink
                to="/politique-de-confidentialite"
                className="text-blue-500 no-underline hover:underline"
              >
                {language === "fr"
                  ? "politique de confidentialité"
                  : "Privacy Policy"}
              </NavLink>
              .
            </div>
        </div>
      </div>
    </div>
  );
}
